import React, { useEffect, useRef } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import classNames from 'classnames';
import { useActivePremiumAchievementIcon } from '../../../../hooks/shared/achievements/useActivePremiumAchievementIcon';

const GameResultModalRatingItem = React.forwardRef(function GameResultModalRatingItem(
  { setIsVisible, position, isInsideRating, isReservation, score, username, iconId, isUser },
  ref,
) {
  const userRef = useRef();

  const iconImage = useActivePremiumAchievementIcon({ extraPremiumIcon: iconId });

  useEffect(() => {
    if (!isUser) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const { isIntersecting } = entry ?? {};
        setIsVisible(isIntersecting);
      },
      { root: null, rootMargin: '0px', threshold: 0.1 },
    );

    observer.observe(userRef.current);
    return () => observer.disconnect();
  }, [isUser]);

  return (
    <div
      className={classNames('game-result-modal__rating-item', {
        'game-result-modal__rating-item-user': isUser || isReservation,
        'game-result-modal__rating-item-reservation': isReservation,
      })}
      {...(isUser && { ref: userRef })}
    >
      <div className={'game-result-modal__rating-item-index'}>{safeHTML(position)}</div>
      <div className={'game-result-modal__rating-item-name'}>{safeHTML(username)}</div>
      {iconImage && <img src={iconImage} className={'game-result-modal__rating-item-image'} alt={''} />}
      <div className={'game-result-modal__rating-item-count'}>{safeHTML(score)}</div>
    </div>
  );
});
export default GameResultModalRatingItem;
GameResultModalRatingItem.propTypes = {};
